export const GET_ACCOUNTS = "GET_ACCOUNTS"
export const GET_ACCOUNTS_FAIL = "GET_ACCOUNTS_FAIL"
export const GET_ACCOUNTS_SUCCESS = "GET_ACCOUNTS_SUCCESS"

export const ADD_NEW_ACCOUNT = "ADD_NEW_ACCOUNT"
export const ADD_ACCOUNT_SUCCESS = "ADD_ACCOUNT_SUCCESS"
export const ADD_ACCOUNT_FAIL = "ADD_ACCOUNT_FAIL"

export const UPDATE_ACCOUNT = "UPDATE_ACCOUNT"
export const UPDATE_ACCOUNT_SUCCESS = "UPDATE_ACCOUNT_SUCCESS"
export const UPDATE_ACCOUNT_FAIL = "UPDATE_ACCOUNT_FAIL"

export const CHANGE_PASSWORD = "CHANGE_PASSWORD"
export const CHANGE_PASSWORD_SUCCESS = "CHANGE_PASSWORD_SUCCESS"
export const CHANGE_PASSWORD_FAIL = "CHANGE_PASSWORD_FAIL"

export const DELETE_ACCOUNT = "DELETE_ACCOUNT"
export const DELETE_ACCOUNT_SUCCESS = "DELETE_ACCOUNT_SUCCESS"
export const DELETE_ACCOUNT_FAIL = "DELETE_ACCOUNT_FAIL"


// SEND INVITATION
export const SEND_INVITATION = "SEND_INVITATION"
export const SEND_INVITATION_SUCCESS = "SEND_INVITATION_SUCCESS"
export const SEND_INVITATION_FAIL = "SEND_INVITATION_FAIL"

// RESEND INVITATION
export const RESEND_INVITATION = "RESEND_INVITATION"
export const RESEND_INVITATION_SUCCESS = "RESEND_INVITATION_SUCCESS"
export const RESEND_INVITATION_FAIL = "RESEND_INVITATION_FAIL"

// ACCEPT INVITATION
export const ACCEPT_INVITATION = "ACCEPT_INVITATION"
export const ACCEPT_INVITATION_SUCCESS = "ACCEPT_INVITATION_SUCCESS"
export const ACCEPT_INVITATION_FAIL = "ACCEPT_INVITATION_FAIL"

// RESEND INVITATION CODE 
export const RESEND_INVITATION_CODE = "RESEND_INVITATION_CODE"
export const RESEND_INVITATION_CODE_SUCCESS = "RESEND_INVITATION_CODE_SUCCESS"
export const RESEND_INVITATION_CODE_FAIL = "RESEND_INVITATION_CODE_FAIL"

// CREATE PASSWORD
export const CREATE_PASSWORD = "CREATE_PASSWORD"
export const CREATE_PASSWORD_SUCCESS = "CREATE_PASSWORD_SUCCESS"
export const CREATE_PASSWORD_FAIL = "CREATE_PASSWORD_FAIL"


// LOCK ACCOUNT
export const LOCK_ACCOUNT = "LOCK_ACCOUNT";
export const LOCK_ACCOUNT_SUCCESS = "LOCK_ACCOUNT_SUCCESS";
export const LOCK_ACCOUNT_FAIL = "LOCK_ACCOUNT_FAIL";

// UNLOCK ACCOUNT
export const UNLOCK_ACCOUNT = "UNLOCK_ACCOUNT";
export const UNLOCK_ACCOUNT_SUCCESS = "UNLOCK_ACCOUNT_SUCCESS";
export const UNLOCK_ACCOUNT_FAIL = "UNLOCK_ACCOUNT_FAIL";

// ENABLE TWO FACTOR
export const ENABLE_TWO_FACTOR = "ENABLE_TWO_FACTOR";
export const ENABLE_TWO_FACTOR_SUCCESS = "ENABLE_TWO_FACTOR_SUCCESS";
export const ENABLE_TWO_FACTOR_FAIL = "ENABLE_TWO_FACTOR_FAIL";

// DISABLE TWO FACTOR
export const DISABLE_TWO_FACTOR = "DISABLE_TWO_FACTOR";
export const DISABLE_TWO_FACTOR_SUCCESS = "DISABLE_TWO_FACTOR_SUCCESS";
export const DISABLE_TWO_FACTOR_FAIL = "DISABLE_TWO_FACTOR_FAIL";

// VERIFY TWO FACTOR 
export const VERIFY_TWO_FACTOR = "VERIFY_TWO_FACTOR";
export const VERIFY_TWO_FACTOR_SUCCESS = "VERIFY_TWO_FACTOR_SUCCESS";
export const VERIFY_TWO_FACTOR_FAIL = "VERIFY_TWO_FACTOR_FAIL";

// RESEND TWO FACTOR CODE
export const RESEND_TWO_FACTOR_CODE = "RESEND_TWO_FACTOR_CODE";
export const RESEND_TWO_FACTOR_CODE_SUCCESS = "RESEND_TWO_FACTOR_CODE_SUCCESS";
export const RESEND_TWO_FACTOR_CODE_FAIL = "RESEND_TWO_FACTOR_CODE_FAIL";







